import React from 'react'
import './portifolio.css'
import IMG1 from '../../acesset/ME5.png'
import IMG2 from '../../acesset/mm6.jpg'
import SMS from '../../acesset/sms.png'

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Import Swiper core and required modules
import { Navigation, Pagination, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

// Portfolio data - Easy to add more projects!
const portfolioData = [
  {
    id: 1,
    image: IMG2,
    title: 'Build Telehealth Software Both " Mobile & Web "',
    github: 'https://github.com/Charly070321',
    demo: 'https://telehealth.mylikita.com/',
    featured: true
  },
  {
    id: 2,
    image: SMS,
    title: 'School Management System',
    github: 'https://github.com/actioninstitute/SMS',
    demo: 'https://realschoolmanagementsystem.netlify.app',
    featured: true
  },
  {
    id: 3,
    image: IMG1,
    title: 'Work On Internal Revenue System Solution',
    github: 'https://github.com/Charly070321',
    demo: 'https://dribble.com/ReignB_Pixels',
    featured: false
  },
  {
    id: 4,
    image: IMG1,
    title: 'MYLIKITA: EHR System',
    github: 'https://github.com/Charly070321',
    demo: 'https://dribble.com/ReignB_Pixels',
    featured: false
  },
  {
    id: 5,
    image: IMG1,
    title: 'Task Management System',
    github: 'https://github.com/Charly070321',
    demo: 'https://dribble.com/ReignB_Pixels',
    featured: false
  },
  {
    id: 6,
    image: IMG1,
    title: 'Employee Management System',
    github: 'https://github.com/Charly070321',
    demo: 'https://dribble.com/ReignB_Pixels',
    featured: false
  }
  // 🎯 ADD MORE PROJECTS HERE! Just copy the format above
  // {
  //   id: 7,
  //   image: YOUR_IMAGE,
  //   title: 'Your Project Title',
  //   github: 'https://github.com/yourrepo',
  //   demo: 'https://yourproject.com',
  //   featured: false
  // },
];

const Portifolio = () => {
  return (
    <section id='portifolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>
      <p className='portfolio-subtitle'>
        Swipe or use arrows to see more projects →
      </p>
    
      <div className="container">
        <Swiper
          className='portifolio__container'
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          loop={true}
          loopAdditionalSlides={2}
          watchSlidesProgress={true}
          breakpoints={{
            // Mobile
            0: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            // Tablet
            768: {
              slidesPerView: 2,
              spaceBetween: 25,
            },
            // Desktop
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            }
          }}
        >
          {portfolioData.map(({ id, image, title, github, demo, featured }) => (
            <SwiperSlide key={id}>
              <article className='portifolio__item'>
                <div className='portifolio__item-image'>
                  <img src={image} alt={title} />
                </div>
                <div className='portifolio__item-content'>
                  <h3>{title}</h3>
                  <div className='portifolio__item-cta'>
                    <a href={github} className='btn' target='_blank' rel="noreferrer">Github</a>
                    <a href={demo} className='btn btn-primary' target='_blank' rel="noreferrer">Live Demo</a>
                  </div>
                </div>
                {featured && <span className='featured-badge'>Featured</span>}
              </article>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  )
}

export default Portifolio
